import React from 'react'
import { FaCopy } from 'react-icons/fa';
import MyFineWearProfile from '../images/MyFineWearProfile.png';

function Dashboard() {
  const style = { color: "#ABAEC1", width: "19.66px", height: "19.66px", position: "absolute", top: "6.55px", left: "0px", right: "62.66px", bottom: "6.89" }
  return (
    <>
      <section className="Dashboard-container">

        <div className="MyFineWears">

          <div className="MyFineWears-Subcon">
            <img className="MyFineWears-image" src={MyFineWearProfile} alt="" />
            <h1 className="dash-H1">Myfinewears.smartbiz.shop</h1>
            <div className="copy-icon">
              <h3 className="icon-text"> <FaCopy style={style} /> Copy </h3>
            </div>
          </div>

          <div className="MyFineWears-SubCon2">
            <div className="TO-TW-CON">
            </div>

            <p>20,000</p>

            <div className="Figure-Con">
              <div className=""></div>
              <div className=""></div>
              <div className=""></div>
              <div className=""></div>
            </div>
          </div>

          <div className="MyFineWears-SubCon3">
            <h3>TODO</h3>
            <div className="Todo-Input-Con">
              <input type="text" />
              <input type="text" />
              <input type="text" />
              <input type="text" />
              <input type="text" />
            </div>
          </div>
          <div className="MyFineWears-SubCon3">
            <h3>Quick Actions</h3>

          </div>
        </div>
      </section>

    </>
  )
}

export default Dashboard
